const baseUrl = process.env.API_BASE_URL + "/middleware";
const baseImage = process.env.IMG_BASE_URL;
const baseImageProduct = process.env.IMG_BASE_URL + "/catalog/product";

const api = {
  advancedSearch: {
    get_advanced_search: `${baseUrl}/advancedSearch`,
    search_category: `${baseUrl}/search_category`,
    search_attribute: `${baseUrl}/search_attribute`,
  },
  video: {
    get_video_exclude_list: `${baseUrl}/get_video_exclude_list`,
    get_video_live: `${baseUrl}/get_video_live`,
    create_access_token: `${baseUrl}/create_access_token`,
    post_video_review: `${baseUrl}/post_video_review`,
    save_callback_book: `${baseUrl}/save_callback_book`,
    list_stores: `${baseUrl}/list_stores`,
  },
  config: {
    config_list: `${baseUrl}/config_list`,
    config_ads: `${baseUrl}/config_ads`,
    config_url_rewrite: `${baseUrl}/config_url_rewrite`,
    config_campaign: `${baseUrl}/config_campaign`,
    config_popup_countdown: `${baseUrl}/config_popup_countdown`,
  },
  otp: {
    get_captcha: `${baseUrl}/get_captcha`,
    check_captcha: `${baseUrl}/check_captcha`,
    get_otp_login_v2: `${baseUrl}/get_otp_login_v2`,
    get_otp_checkout: `${baseUrl}/get_otp_checkout`,
    get_zalo_otp_login: `${baseUrl}/get_zalo_otp_login`,
    get_zalo_otp_checkout: `${baseUrl}/get_zalo_otp_checkout`,
    get_verify_otp_captcha: `${baseUrl}/get_verify_otp_captcha`,
    post_otp: `${baseUrl}/post_otp`,
    find_customer: `${baseUrl}/find_customer`,
    login_employee: `${baseUrl}/login_employee`,
    remove_cart: `${baseUrl}/remove_cart`,
    crypto_key: "98765432198765432198765432198765",
    crypto_iv: "98765432198765432198765432198765",
    post_otp_checkout: `${baseUrl}/post_otp_checkout`,
  },
  storelocator: {
    storelocator_city: `${baseUrl}/storelocator_city`,
    storelocator_top_stores: `${baseUrl}/storelocator_top_stores`,
    storelocator_find_product: `${baseUrl}/storelocator_find_product`,
    storelocator_location_product: `${baseUrl}/storelocator_location_product`,
    storelocator_get_store_detail: `${baseUrl}/storelocator_get_store_detail`,
    storelocator_find_stores: `${baseUrl}/storelocator_find_stores`,
  },
  region: {
    region_getcity: `${baseUrl}/region_getcity`,
    region_getstates: `${baseUrl}/region_getstates`,
    region_getwards: `${baseUrl}/region_getwards`,
    country_getRegion: `${baseUrl}/country_getRegion`,
    country_getWard: `${baseUrl}/country_getWard`,
  },
  megaMenu: {
    get_mega_menu: `${baseUrl}/get_mega_menu`,
  },
  faq: {
    faq_get_faqlist: `${baseUrl}/faq_get_faqlist`,
    faq_get_faqbyid: `${baseUrl}/faq_get_faqbyid`,
    get_faq_group_list: `${baseUrl}/get_faq_group_list`,
    get_faq_group_byid: `${baseUrl}/get_faq_group_byid`,
  },
  blog: {
    blog_post: `${baseUrl}/blog_post`,
    blog_post_byid: `${baseUrl}/blog_post_byid`,
    blog_post_list: `${baseUrl}/blog_post_list`,
    blog_post_news: `${baseUrl}/blog_post_news`,
    blog_search: `${baseUrl}/blog_search`,
    blog_feature_post: `${baseUrl}/blog_feature_post`,
  },
  customer: {
    customer_lock: `${baseUrl}/customer_lock`,
    customer_tax_info: `${baseUrl}/customer_tax_info`,
    customer_search_history: `${baseUrl}/customer_search_history`,
    customer_create_pre_res_partner: `${baseUrl}/customer_create_pre_res_partner`,
    customer_unlink: `${baseUrl}/customer_unlink`,
    customer_postbackorder: `${baseUrl}/customer_postbackorder`,
    customer_list_order_by_filter: `${baseUrl}/customer_list_order_by_filter`,
    customer_getlistvoucher: `${baseUrl}/customer_getlistvoucher`,
    customer_delete_address: `${baseUrl}/customer_delete_address`,
    customer_updateaddress: `${baseUrl}/customer_updateaddress`,
  },
  layout: {
    layout_list: `${baseUrl}/layout_list`,
    watchshop: `${baseUrl}/video_watchshop`,
  },
  sales: {
    change_payment: `${baseUrl}/change_payment`,
    product_recommendation: `${baseUrl}/product_recommendation`,
    recommend_products_ids: `${baseUrl}/recommend_products_ids`,
    recommend_product_cart: `${baseUrl}/recommend_product_cart`,
  },
  erp: {
    loyalty_by_code: `${baseUrl}/loyalty_by_code`,
    transaction_history_by_code: `${baseUrl}/transaction_history_by_code`,
    vouchers_by_phone: `${baseUrl}/vouchers_by_phone`,
    use_loyalty: `${baseUrl}/use_loyalty`,
    loyalty_history_by_code: `${baseUrl}/loyalty_history_by_code`,
    order_status: `${baseUrl}/order_status`,
    tracking_order: `${baseUrl}/tracking_order`,
    list_order: `${baseUrl}/list_order`,
    create_account_partner: `${baseUrl}/create_account_partner`,
  },
  erpVoucher: {
    get_voucher: `${baseUrl}/get_voucher`,
    random_voucher: `${baseUrl}/random_voucher`,
    voucher_checks: `${baseUrl}/voucher_checks`,
    validate_Voucher: `${baseUrl}/validate_Voucher`,
    form_voucher: `${baseUrl}/form_voucher`,
    voucher_infomation: `${baseUrl}/voucher_infomation`,
    list_coupon_information: `${baseUrl}/list_coupon_information`,
    collect_voucher: `${baseUrl}/collect_voucher`,
    game_code: `${baseUrl}/game_code`,
  },
  multiCoupon: {
    multi_coupon_me_apply: `${baseUrl}/multi_coupon_me_apply`,
    multi_coupon_guest_apply: `${baseUrl}/multi_coupon_guest_apply`,
  },
  luckyWheel: {
    lucky_wheel_check: `${baseUrl}/lucky_wheel_check`,
    lucky_wheel_info: `${baseUrl}/lucky_wheel_info`,
    lucky_wheel_submit: `${baseUrl}/lucky_wheel_submit`,
  },
  freeGift: {
    free_gift_list: `${baseUrl}/free_gift_list`,
    free_gift_addcart: `${baseUrl}/free_gift_addcart`,
  },
  shopeepay: {
    shopeepay_create_qr: `${baseUrl}/shopeepay_create_qr`,
    shopeepay_create_payment: `${baseUrl}/shopeepay_create_payment`,
    shopeepay_trans: `${baseUrl}/shopeepay_trans`,
    shopeepay_order_ipn: `${baseUrl}/shopeepay_order_ipn`,
  },
  vnpay: {
    vnpay_create_payment: `${baseUrl}/vnpay_create_payment`,
    vnpay_callback: `${baseUrl}/vnpay_callback`,
    vnpay_trans: `${baseUrl}/vnpay_trans`,
    vnpay_querydr: `${baseUrl}/vnpay_querydr`,
    vnpay_order_ipn: `${baseUrl}/vnpay_order_ipn`,
  },
  flashsale: {
    flashsale_deals: `${baseUrl}/flashsale_deals`,
    flashsale_product: `${baseUrl}/flashsale_product`,
  },
  viettelpay: {
    viettelpay_create_payment: `${baseUrl}/viettelpay_create_payment`,
    viettelpay_trans: `${baseUrl}/viettelpay_trans`,
  },
  stock: {
    stock_check: `${baseUrl}/stock_check`,
    stock_get_stock_list: `${baseUrl}/stock_get_stock_list`,
    stock_get_social_sale_list: `${baseUrl}/stock_get_social_sale_list`,
    stock_get_stock_by_province: `${baseUrl}/stock_get_stock_by_province`,
    stock_get_stock_lists_with_cache: `${baseUrl}/stock_get_stock_lists_with_cache`,
  },
  user: {
    get_loyalty: `${baseUrl}/get_loyalty`,
    get_me: `${baseUrl}/get_me`,
    get_order_history: `${baseUrl}/get_order_history`,
    get_order_offline: `${baseUrl}/get_order_offline`,
    check_user_exist: `${baseUrl}/check_user_exist`,
  },
  reference: {
    reference_code: `${baseUrl}/reference_code`,
    reference_save: `${baseUrl}/reference_save`,
    reference_history: `${baseUrl}/reference_history`,
  },
  notifications: {
    notifications_device: `${baseUrl}/notifications_device`,
  },
  recapcha: {
    key_recaptcha: "6LcebbolAAAAAO4jJNLVZIrsl0WXMVYw4JZbPvPV",
  },

};

export const goongjsConfig = {
  keyGoong: "2f74gfo7w0U00BHWuogV8KNaRdvDTdttNapehuux",
  apiKeyGoong: "P1PJ9y1Aincmm72KeBZkeYsIpKu55GcUNihloLlK",
};

export const magento = {
  url: baseImage,
  media_url: baseImage,
  urlSwatch: baseImage + "/attribute/swatch",
  swatchType: 2,
};

export const images = {
  baseUrl: baseImageProduct,
  cache: "/cache/",
  productList: "500_750",
  productDetail: "1517_2000",
  productSwatch: "100_142",
  productPlaceholder: "/assets/placeholder.jpg",
};

export const products = {
  fieldsToCompact: {
    minimal_price: "mp",
    has_options: "ho",
    url_key: "u",
    status: "s",
    required_options: "ro",
    name: "nm",
    tax_class_id: "tci",
    description: "desc",
    minimal_regular_price: "mrp",
    final_price: "fp",
    price: "p",
    special_price: "sp",
    original_final_price: "ofp",
    original_price: "op",
    original_special_price: "osp",
    final_price_incl_tax: "fpit",
    original_price_incl_tax: "opit",
    price_incl_tax: "pit",
    special_price_incl_tax: "spit",
    final_price_tax: "fpt",
    price_tax: "pt",
    special_price_tax: "spt",
    original_price_tax: "opt",
    image: "i",
    small_image: "si",
    thumbnail: "t",
  },
  disablePersistentProductsCache: true,
  useMagentoUrlKeys: true,
  setFirstVarianAsDefaultInURL: false,
  configurableChildrenStockPrefetchStatic: false,
  configurableChildrenStockPrefetchDynamic: true,
  configurableChildrenStockPrefetchStaticPrefetchCount: 8,
  filterUnavailableVariants: false,
  listOutOfStockProducts: true,
  preventConfigurableChildrenDirectAccess: true,
  alwaysSyncPlatformPricesOver: false,
  alwaysSyncPricesClientSide: false,
  clearPricesBeforePlatformSync: false,
  waitForPlatformSync: false,
  setupVariantByAttributeCode: true,
  calculateBundlePriceByOptions: true,
  endpoint: "https://canifa.com/api/product",
  defaultFilters: ["mastercolor", "color", "erin_recommends", "price", "size"],
  systemFilterNames: ["sort"],
  maxFiltersQuerySize: 999,
  routerFiltersSource: "query",
  filterFieldMapping: {
    "category.name": "category.name.keyword",
  },
  colorMappings: {
    "Melange graphite": "#eeeeee",
  },
  defaultSortBy: {
    attribute: "position",
    order: "asc",
  },
  sortByAttributes: {
    "Position: First to last": "position:asc",
    "Price: Low to high": "final_price",
    "Price: High to low": "final_price:desc",
    Latest: "updated_at:desc",
    "Position: Last to first": "position:desc",
  },
  gallery: {
    mergeConfigurableChildren: true,
    imageAttributes: ["image", "thumbnail", "small_image"],
    width: 800,
    height: 1000,
    thumbnails: {
      width: 212,
      height: 284,
    },
  },
  thumbnails: {
    width: 250,
    height: 375,
  },
  filterAggregationSize: {
    default: 10,
    size: 10,
    color: 10,
  },
  priceFilterKey: "final_price",
  priceFilters: {
    ranges: [
      {
        from: 0,
        to: 200000,
      },
      {
        from: 200000,
        to: 400000,
      },
      {
        from: 400000,
        to: 600000,
      },
      {
        from: 600000,
        to: 800000,
      },
      {
        from: 800000,
        to: 1000000,
      },
      {
        from: 1000000,
        to: 1600000,
      },
      {
        from: 1600000,
      },
    ],
  },
};

export const seo = {
  useUrlDispatcher: true,
  disableUrlRoutesPersistentCache: true,
  defaultTitle: "Canifa",
};

export const storeViews = {
  multistore: true,
  commonCache: false,
};

export default api;
